import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgKebab(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.0001 5.05078C14.5365 5.05078 13.3501 6.23723 13.3501 7.70078C13.3501 9.16434 14.5365 10.3508 16.0001 10.3508C17.4637 10.3508 18.6501 9.16434 18.6501 7.70078C18.6501 6.23723 17.4637 5.05078 16.0001 5.05078Z"
      />
      <path
        fill="currentColor"
        d="M15.9999 13.3496C14.5363 13.3496 13.3499 14.5361 13.3499 15.9996C13.3499 17.4632 14.5363 18.6496 15.9999 18.6496C17.4634 18.6496 18.6499 17.4632 18.6499 15.9996C18.6499 14.5361 17.4634 13.3496 15.9999 13.3496Z"
      />
      <path
        fill="currentColor"
        d="M13.3499 24.3004C13.3499 22.8368 14.5363 21.6504 15.9999 21.6504C17.4634 21.6504 18.6499 22.8368 18.6499 24.3004C18.6499 25.7639 17.4634 26.9504 15.9999 26.9504C14.5363 26.9504 13.3499 25.7639 13.3499 24.3004Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgKebab);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
